import { createRef } from 'react'
import { initAutoAjaxSelect2 } from 'auto_select2/ajax_select2'

export default class AjaxTagsInput extends React.Component {
  constructor (props) {
    super(props)
    this.inputRef = createRef(null)
  }

  UNSAFE_componentWillMount () {
    if (this.props.field === 'skills') this.field = 'skill' // TODO: check is it necessary
    this.options = {
      placeholder: this.props.placeholder || '',
      additional_ajax_data: {
        selector: '.dependent-input'
      }
    }
  }

  componentDidMount () {
    $(this.inputRef.current).ready(() => { // jQuery must be ready for call initAutoAjaxSelect2()
      initAutoAjaxSelect2()
      // label handler
      this.select2 = $(this.inputRef.current).data('select2')
      this.select2.container.attr('data-label', this.props.value ? this.props.placeholder || '' : '')
      $(this.inputRef.current).on('change select2-blur', (e) => {
        setTimeout(() => {
          $(this.select2.container).attr('data-label', e.target.value ? this.props.placeholder || '' : '')
            .toggleClass('show-labelholder', !!e.target.value)
        }, 10)
      })

      $(this.inputRef.current).on('change', (e) => {
        // Callback
        if (typeof this.props.onChange === 'function') this.props.onChange($(this.inputRef.current).val(), e)
      })
    })
  }

  render () {
    const { name, value, field, select2url, disabled } = this.props
    return (
      <input
        type='hidden' name={name} value={value}
        className={`auto-ajax-select2 labelholder ${value && 'show-labelholder'}`}
        data-s2-options={JSON.stringify(this.options)}
        data-s2-href={`/select2_autocompletes/${select2url || this.field || field}`}
        data-s2-limit='25' tabIndex='-1'
        ref={this.inputRef}
        disabled={disabled}
        id={field}
      />

    )
  }
}

AjaxTagsInput.propTypes = {
  field: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  select2url: PropTypes.string,
  onLoad: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
